export default __webpack_public_path__ + "static/media/mops-pluesch.b261e480.jpg";